export default __webpack_public_path__ + "static/media/qf.ce56fb72.webp";